<template>
  <v-card class="com-mb-card vg-content">
    <v-divider></v-divider>
    <v-col class="com-mb-card-contents-none-border">
      <v-col class="com-mb-card-title px-0 pt-2 pb-0 ma-0">
        <span class="com-mb-card-title pl-2">{{ text.mapSetTitle }}</span>
      </v-col>
    </v-col>
    <v-row align="center" class="pt-1 pb-1">
      <v-col cols="5" class="pt-2 pl-8 pb-0">
        <span class="success--text">{{ text.mapSetPositionLabel }}</span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mr-2">
        <span>
          <v-select
            v-model="pointIndex"
            required
            dense
            :items="pointList"
            item-text="name"
            item-value="id"
            item-color="success"
            class="select-text"
            hide-details
          ></v-select>
        </span>
      </v-col>
    </v-row>
    <v-row align="center" class="pt-1 pb-1">
      <v-col cols="5" class="pt-2 pl-8 pb-0">
        <span class="success--text">{{ text.obSetLabel }}</span>
      </v-col>
      <v-col cols="6" class="pt-0 pb-0 mr-2">
        <v-select
          v-model="dispIndex"
          required
          dense
          :items="setObDisplayList"
          item-text="name"
          item-value="id"
          item-color="success"
          class="select-text"
          hide-details
        ></v-select>
      </v-col>
    </v-row>
    <v-row v-if="dispIndex === 'disp5'" justify="end">
      <v-col cols="5">
        <v-btn class="vc-btn-item py-0 px-1" @click="clickCustom">{{
          text.toIdvSetScreen
        }}</v-btn>
      </v-col>
    </v-row>
    <v-divider></v-divider>
    <v-col class="com-mb-card-contents-none-border pa-0">
      <v-col class="com-mb-card-title pl-2 pb-0 pt-2">
        <span class="com-mb-card-title">{{ text.displaySetStgTitle }}</span>
      </v-col>
      <v-btn
        class="ms-4 mt-2 mb-2"
        rounded
        depressed
        :outlined="!isStgMode('0')"
        x-small
        color="success"
        @click="changeStgMode('0')"
      >
        <div>{{ stgMsg.normalStgDisplay }}</div>
      </v-btn>
      <v-btn
        class="ms-2 mt-2 mb-2"
        rounded
        depressed
        :outlined="!isStgMode('1')"
        x-small
        color="success"
        @click="changeStgMode('1')"
      >
        <div>{{ stgMsg.topendStgDisplay }}</div>
      </v-btn>
      <v-divider></v-divider>
      <v-col class="com-mb-card-title pl-2 pb-0 pt-2">
        <span class="com-mb-card-title">{{ text.displaySetCardTitle }}</span>
      </v-col>
      <v-btn
        class="ms-4 mt-2 mb-2"
        rounded
        depressed
        :outlined="!isFldctlParty('0')"
        x-small
        color="success"
        @click="changeMode('0')"
      >
        <div>{{ text.genDiplay }}</div>
      </v-btn>
      <v-btn
        class="ms-2 mt-2 mb-2"
        rounded
        depressed
        :outlined="!isFldctlParty('1')"
        x-small
        color="success"
        @click="changeMode('1')"
      >
        <div>{{ text.fldDisplay }}</div>
      </v-btn>
    </v-col>
  </v-card>
</template>
<script>
/**
 * 川の防災情報 表示設定 初期表示カード
 * VcDefault.vue
 * @author LIS
 */
import mixin from "./../../lib/mixin.js";
import WebStorage from "./../../lib/webStorage.js";
import PageLog from "./../../lib/pageLog.js";
export default {
  name: "vc-default",
  mixins: [mixin],
  data() {
    return {
      pointIndex: "",
      dispIndex: "",
      modeIndex: "",
      stgModeIndex: "",
      text: {
        mapSetTitle: "地図の初期表示設定",
        mapSetPositionLabel: "初期表示位置",
        obSetLabel: "表示観測所選択",
        toIdvSetScreen: "個別設定の登録画面へ",
        displaySetCardTitle: "一般用表示・水防団用表示切替",
        displaySetStgTitle: "水位表示切替",
        genDiplay: "一般用表示",
        fldDisplay: "水防団用表示",
      },
      setObDisplayList: [
        { name: "水位・ダム・河川カメラ", id: "disp0" },
        { name: "雨量", id: "disp1" },
        { name: "水質・海岸・積雪深", id: "disp2" },
        { name: "非表示", id: "disp3" },
        { name: "登録観測所", id: "disp4" },
        { name: "個別設定", id: "disp5" },
      ],
    };
  },
  /**
   * マウント後イベント
   */
  mounted() {
    this.$log.debug("[VcDefault] mounted()");
    // アクセスログ出力
    PageLog.log({
      page_log: "dispsetting",
      device_sb: this.$store.state.app.mode,
      fc_flg: this.$store.getters["app/isFldCtl"],
    });

    // webストレージ読み込み
    let info = WebStorage.getDefaultInfo();

    // 地点の初期値を設定
    if (info.point1) {
      this.pointIndex = "point0";
    } else if (info.point2) {
      this.pointIndex = "point1";
    } else if (info.point3) {
      this.pointIndex = "point2";
    } else if (info.point4) {
      this.pointIndex = "point3";
    } else if (info.point5) {
      this.pointIndex = "point4";
    } else if (info.pointDefault) {
      this.pointIndex = "point5";
    }

    // 表示の初期値設定
    if (info.disp1) {
      this.dispIndex = "disp0";
    } else if (info.disp2) {
      this.dispIndex = "disp1";
    } else if (info.disp3) {
      this.dispIndex = "disp2";
    } else if (info.disp4) {
      this.dispIndex = "disp3";
    } else if (info.disp5) {
      this.dispIndex = "disp4";
    } else if (info.dispCustom) {
      this.dispIndex = "disp5";
    }

    // モードの初期値設定
    if (this.isFldCtl) {
      this.modeIndex = "mode1";
    } else {
      this.modeIndex = "mode0";
    }

    // 水位表示の初期値設定
    if (this.stgMode) {
      this.stgModeIndex = "stgMode0";
    } else {
      this.stgModeIndex = "stgMode1";
    }
  },
  computed: {
    /** 選択値 */
    value: {
      get() {
        return {
          point: this.pointIndex,
          disp: this.dispIndex,
          mode: this.modeIndex,
          stgMode: this.stgModeIndex,
        };
      },
    },
    /**
     * 水位表示
     */
    stgMode: {
      get() {
        return this.$store.state.app.stgMode;
      },
    },
    /** 選択地点インデックス */
    selectedPointIndex: {
      get() {
        return this.$store.state.viewConfig.selectedPoint;
      },
    },
    /** 選択地点 */
    selectedPoint: {
      get() {
        if (this.selectedPointIndex === "") {
          return "";
        } else {
          return this.points[this.$store.state.viewConfig.selectedPoint];
        }
      },
    },
    /**
     * 水防団モード
     */
    fldCtlParty: {
      get() {
        return this.$store.state.app.fldCtlParty;
      },
    },
    /**
     * 水防団モード
     */
    isFldCtl: {
      get() {
        return this.$store.getters["app/isFldCtl"];
      },
    },
    /**
     * 水位表示切替メッセージ
     */
    stgMsg: {
      get() {
        return this.$store.state.app.config.messageConfig.stg;
      },
    },
    /** webストレージより登録地点を取得 */
    pointList() {
      let points = [];
      let info, point;

      for (let i = 1; i <= WebStorage.length(); i++) {
        info = WebStorage.getPointInfo(i);
        point = { name: "" + i, id: "" };
        if (info != null && info.name != null && info.pointIndex != null) {
          if (info.name != "") {
            point.name = info.name;
          } else {
            point.name = "地点" + (info.pointIndex + 1);
          }
          point.id = "point" + info.pointIndex;
          points.push(point);
        }
      }
      point = { name: "日本全国", id: "point5" };
      points.push(point);
      return points;
    },
  },
  methods: {
    /**
     * 個別設定画面ボタンクリック
     */
    clickCustom() {
      this.$log.debug("[VcDefault] clickCustom()");
      this.$store.commit("app/setContent", "VcCustom");
    },
    /**
     * 水防団モード切替
     */
    changeMode() {
      this.isGenMode = !this.isGenMode;
      var mode = "";
      if (this.modeIndex === "mode0") {
        this.modeIndex = "mode1";
        mode = "1";
      } else {
        this.modeIndex = "mode0";
        mode = "0";
      }
      this.$log.debug("[VcDefault] changeMode(" + mode + ")");
      this.$store.commit("app/setFldCtlParty", mode);
      this.routerFldCtlParty();
      this.modeIndex = "mode" + mode;
    },
    /**
     * 水位表示の切り替え
     */
    changeStgMode(idx) {
      this.$log.debug("[VcDefault] changeStgMode(" + idx + ")");
      this.$store.commit("app/setStgMode", idx);
      this.stgModeIndex = "stgMode" + idx;
    },
    /**
     * 水位表示取得
     */
    isStgMode(val) {
      let stgModeNumber = this.stgMode;
      return stgModeNumber === val;
    },
    /**
     * 水防団モード取得
     */
    isFldctlParty(val) {
      let modeNumber = this.fldCtlParty;
      return modeNumber === val;
    },
  },
  watch: {
    /**
     * 選択値変更時
     */
    value() {
      this.$log.debug("[VcDefault] watch(value)");
      const info = WebStorage.getDefaultInfo();
      // 選択値からjson作成
      let defaultInfo = {
        point1: this.value.point === "point0" ? true : false,
        point2: this.value.point === "point1" ? true : false,
        point3: this.value.point === "point2" ? true : false,
        point4: this.value.point === "point3" ? true : false,
        point5: this.value.point === "point4" ? true : false,
        pointDefault: this.value.point === "point5" ? true : false,
        disp1: this.value.disp === "disp0" ? true : false,
        disp2: this.value.disp === "disp1" ? true : false,
        disp3: this.value.disp === "disp2" ? true : false,
        disp4: this.value.disp === "disp3" ? true : false,
        disp5: this.value.disp === "disp4" ? true : false,
        dispCustom: this.value.disp === "disp5" ? true : false,
        general: this.value.mode === "mode0" ? true : false,
        flood: this.value.mode === "mode1" ? true : false,
        normalstg: this.value.stgMode === "stgMode0" ? true : false,
        topendstg: this.value.stgMode === "stgMode1" ? true : false,
        mapType: info.mapType,
        viewRd: info.viewRd,
        viewRw: info.viewRw,
        viewRvrln: info.viewRvrln,
        viewRp: info.viewRp,
      };
      // webストレージ書き込み
      WebStorage.setDefaultInfo(defaultInfo);
      // webストレージ編集日時更新
      this.$store.commit("map/setEditWebStorageDate", new Date());
    },
  },
};
</script>

<style lang="scss" scoped>
.vc-btn-item {
  font-size: 0.55rem;
}

.vg-content {
  font-size: 12px;
  .select-text {
    font-size: 12px;
  }
}
.com-mb-card-contents-none-border {
  padding: 0;
}
</style>
